module.exports = __webpack_public_path__ + "static/media/SKODA_logo1_blue.d7689573.png";